import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField } from '@material-ui/core';

const FormTextField = ({
  input,
  label,
  meta: { touched, error, submitError },
  ...custom
}) => (
    <div>
      {label ? <Typography variant="caption" display="block">{label}</Typography> : null}
      <TextField
        error={touched && (error || submitError) ? true : false}
        helperText={touched && (error || submitError)}
        margin="dense"
        variant="outlined"
        {...input}
        {...custom}
      />
    </div>
  );

FormTextField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
};

export default FormTextField;



// WEBPACK FOOTER //
// ./src/components/form/FormTextField.js